// NotFound.js

import React from "react";

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100">
      <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
      <p className="text-xl text-gray-600 mb-8">Oops! Page not found.</p>
      <button
        onClick={() => window.history.back()}
        className="bg-gray-700 hover:bg-gray-600 text-white py-2 px-4 rounded"
      >
        Go Back
      </button>
    </div>
  );
};

export default NotFound;
